// Shared types and helpers for reading build-environment variables exposed
// to the browser bundle. Owned by this module because it is used from both
// init.ts (environment / deployment detection) and vcs.ts (VCS detection).
//
// IMPORTANT: each `process.env.NAME` MUST be a LITERAL accessor in the
// caller's source. Webpack DefinePlugin, Next.js, Gatsby, and equivalents
// substitute env vars at build time only when they see the literal form.
// Dynamic lookups (`process.env[name]`, iterating a string array) are NOT
// substituted — they resolve to `undefined` in the browser bundle.
//
// The type unions below are the single source of truth for which env var
// names the SDK reads. They are composed via template-literal types so
// every (prefix × suffix) combination is enumerated at the type level.
// Adding a framework prefix is a one-line edit to `FrameworkPrefix`; adding
// a suffix is a one-line edit to the appropriate suffix union.
/**
 * Return the first truthy value, or undefined. Used to walk the list of
 * framework-prefixed variants of an env var and pick whichever the user's
 * bundler substituted at build time.
 *
 * The falsy check skips empty strings as well as undefined — bundlers that
 * do not substitute a literal leave it as `undefined`, not `""`, so empty
 * is treated as "not set". This is intentional and matches every known
 * `VERCEL_GIT_*` / `REPOSITORY_URL` / etc. value shape (non-empty strings
 * or absent; Vercel PR IDs are positive integer strings, never `"0"`).
 */
export function pickFirstString(...values) {
    for (const value of values) {
        if (value)
            return value;
    }
    return undefined;
}
